import {basicSetup} from 'codemirror';
import {EditorState, Compartment, EditorSelection} from '@codemirror/state';
import {EditorView, keymap} from '@codemirror/view';
import {acceptCompletion} from '@codemirror/autocomplete';
import {expressionlanguage} from '@valtzu/codemirror-lang-el';
import {defaultKeymap} from '@codemirror/commands';

export default (Alpine) => {

    Alpine.data('codeEditorFormComponent', (state, elConfig, htmlId) => {

        let editor = null;
        let editorState = null;
        let elExtension = new Compartment;

        return {
            state,
            editor: undefined,
            elConfig: {},
            htmlId: undefined,
            init: function() {

                this.htmlId = htmlId;
                this.elConfig = elConfig;
                this.render();

                Livewire.on('update-interpretation-expression', (event) => {
                    editor.dispatch({
                        effects: [
                            elExtension.reconfigure(expressionlanguage(event.elConfig))
                        ],
                    });
                });

                // Livewire.on('add-text-to-expression-' + this.htmlId, (event) => {
                //
                //     const transaction = editor.state.changeByRange(range => {
                //         return {
                //             changes: { from: range.from, to: range.to, insert: event.text },
                //             range: EditorSelection.cursor(range.from + event.text.length)
                //         };
                //     });
                //
                //     editor.dispatch(transaction);
                // });
            },

            render() {

                editorState = EditorState.create({
                    extensions: [
                        basicSetup,
                        keymap.of([
                            ...defaultKeymap,
                            {key: 'Tab', run: acceptCompletion}]),
                        elExtension.of(expressionlanguage(this.elConfig)),
                        EditorView.lineWrapping,
                        EditorView.updateListener.of((v) => {
                            if (v.docChanged) {
                                this.state = v.state.doc.toString();
                            }
                        }),
                    ],
                    doc: this.state,
                });

                editor = new EditorView({
                    state: editorState,
                    parent: this.$refs.codeEditor,
                });
            },
        };
    });
}
